import OrgsMenu from './OrgsMenu'
import { dataKey } from './dataKey'

export default OrgsMenu
export { dataKey }
